<script>
export default {
  name: "AnnualRain",
  data() {
    return {
      tableData: [],
      dataDate: '',
      currentDate: '',
      columns: [
        { label: '1月', prop: 'month1Rain' },
        { label: '2月', prop: 'month2Rain' },
        { label: '3月', prop: 'month3Rain' },
        { label: '4月', prop: 'month4Rain' },
        { label: '5月', prop: 'month5Rain' },
        { label: '6月', prop: 'month6Rain' },
        { label: '7月', prop: 'month7Rain' },
        { label: '8月', prop: 'month8Rain' },
        { label: '9月', prop: 'month9Rain' },
        { label: '10月', prop: 'month10Rain' },
        { label: '11月', prop: 'month11Rain' },
        { label: '12月', prop: 'month12Rain' },
        { label: '全年合计', prop: 'total' },
      ]
    }
  },
  methods: {
    init() {
      this.currentDate = this.$moment(new Date()).format('YYYY-MM-DD');
      this.dataDate = this.$moment(new Date()).format('YYYY');
      this.query();
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.stnm === '面雨量') {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    query() {
      this.request.get(`/rm-report-rain/v1/year/report?date=${this.dataDate}`).then(
          (res) => {
            if (res.ok) {
              this.tableData = res.data;
            } else {
              this.$message.error(res.error.message);
            }
          }
      );
    },
    download() {
      this.request.get('/rm-report-rain/v1/year/export',{ params: {date: this.dataDate},responseType: "blob" }).then((res) => {
        try {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          // 这里填保存成的文件名
          a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
          a.click();
          URL.revokeObjectURL(a.href);
          return;
        } catch (error) {
          const reader = new FileReader();
          reader.readAsText(res.data, 'utf-8');
          let _this = this;
          reader.onload=function(){
            const msg = JSON.parse(reader.result);
            if (!msg.ok) {
              if (msg.error.code === 3001) {
                _this.$message.error(msg.error.message);
              } else {
                _this.$message.warning(msg.error.message);
              }
            }
          }
        }
      });
    },
  },
  mounted() {
    this.init();
  },
  watch:{
    "$store.state.head.skCd"() {
      //调用页面查询方法
      this.query();
    },
  }
}
</script>

<template>
  <el-container style="padding: 20px 0;">
    <el-header class="header">
      <el-date-picker
          style="margin-right: 10px;"
          v-model="dataDate"
          format="yyyy"
          value-format="yyyy"
          type="year"
          size="mini"
          :clearable="false"
          placeholder="选择日期">
      </el-date-picker>
      <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="query">
        搜索
      </el-button>
      <el-button
          type="primary"
          size="small"
          class="queryButton queryButtonPadding qDcBtn"
          @click="download">
        <el-image class="qDcImg" :src="require('@/assets/buttonGathers/query-dc.png')"></el-image>
        &nbsp;导出
      </el-button>
    </el-header>
    <el-main style="padding: 20px 0;">
      <el-table
          :data="tableData"
          :span-method="arraySpanMethod"
          style="width: 100%;"
          border
          :header-cell-style="{backgroundColor:'white',fontSize: '1.4rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'bold',fontStretch:'normal',height:'3vh'}"
          height="calc(100vh - 320px)"
          max-height="calc(100vh  - 320px)">
        <el-table-column label="雨量年报表" align="center">
          <el-table-column align="center">
            <template #header>
              <div style="display: flex;justify-content: space-around;">
                <span>制表时间：{{ currentDate }}</span>
                <span>数据时间：{{ dataDate }}</span>
                <span>单位：毫米(mm)</span>
              </div>
            </template>
            <el-table-column
                label="测站信息"
                header-align="center">
              <el-table-column
                  label="测站名称"
                  prop="stnm"
                  width="180"
                  align="center"
                  header-align="center">
              </el-table-column>
              <el-table-column
                  label="测站编码"
                  prop="stcd"
                  width="180"
                  align="center"
                  header-align="center">
              </el-table-column>
            </el-table-column>
            <el-table-column
                v-for="item in columns"
                :label="item.label"
                :prop="item.prop"
                :key="item.prop"
                align="right"
                header-align="center">
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<style scoped>
.header {
  height: 50px;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  position: relative;
}
</style>